import { FC, useCallback } from 'react';
import { ConnectionHandler, useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import CloudSyncIcon from '@mui/icons-material/CloudSync';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';

import { useErrorHandler } from 'lib';
import { useNotification } from 'components/Notifications';

import {
  CateringOptionsSyncMutation,
  CateringOptionsSyncMutation$data,
} from '__generated__/CateringOptionsSyncMutation.graphql';

const CateringOptionsSync: FC = () => {
  const { pop } = useNotification();
  const errorHandler = useErrorHandler<CateringOptionsSyncMutation$data>();

  const [sync, loading] = useMutation<CateringOptionsSyncMutation>(graphql`
    mutation CateringOptionsSyncMutation {
      syncCateringOptions {
        recordsCreated
        recordsSkipped
      }
    }
  `);

  const handleSyncClick = useCallback(() => {
    sync({
      variables: {},

      ...errorHandler({
        onCompleted: ({ syncCateringOptions }) => {
          const { recordsCreated, recordsSkipped } = syncCateringOptions;

          if (recordsCreated > 0) {
            pop(`Sukurta: ${recordsCreated}, pralesita: ${recordsSkipped}`);
          } else {
            pop('Jau atnaujinta');
          }
        },
      }),

      updater: (store, { syncCateringOptions }) => {
        if (syncCateringOptions.recordsCreated > 0) {
          ConnectionHandler.getConnection(
            store.getRoot(),
            'CateringOptionsList_cateringOptions'
          )?.invalidateRecord();
        }
      },
    });
  }, [errorHandler, pop, sync]);

  return (
    <IconButton onClick={handleSyncClick} disabled={loading}>
      {loading ? (
        <CircularProgress size="1rem" />
      ) : (
        <Tooltip title="Atnaujinti iš ETG">
          <CloudSyncIcon />
        </Tooltip>
      )}
    </IconButton>
  );
};

export default CateringOptionsSync;
